import { api } from './config'

export class ListTypeProducts {
    async TypeProduct<T>(data: any): Promise<T> {
       return await api.get('/utils/type/animal/product', {params: data})
    }
} 